function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import remove from 'ramda/src/remove';
import ApiConstants from 'invision-core/src/api/constants';
import i18n from 'invision-core/src/components/i18n/i18n';
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import { getUiNotificationService } from 'invision-core/src/components/injectables/injector.helper';
import CustomerCareKeys from '../../locales/keys';
import createWizardActions from '../helpers/wizard.action.helper';
import { calculateChangeOfServiceOrderQuoteRequestPromise, calculateModifyOrderQuotePromise, calculateOrderQuotePromise, calculateRenewOrderQuotePromise, clearProductOrderQuote, submitGiftOrderPromise, submitModifyOrderPromise, submitOrderPromise, submitRestoreOrderPromise, submitServiceFeatureOrderPromise } from './products.order.actions';
import { transformCartItemInstanceProperties } from '../helpers/instance.property.helper';
var SIMPLE_EPHEMERAL_CART_OPTIONS = {
  PersistCart: false,
  CombineProducts: true
};
var ACTION_PREFIX = 'NEW_PRODUCTS';
var wizardActions = createWizardActions(ACTION_PREFIX);
export var INITIALIZE_PRODUCT_ORDER = 'INITIALIZE_PRODUCT_ORDER';
export var CANCEL_ORDER = wizardActions.CANCEL_WIZARD;
export var GO_TO_NEXT_STEP = wizardActions.GO_TO_NEXT_STEP;
export var GO_TO_PREVIOUS_STEP = wizardActions.GO_TO_PREVIOUS_STEP;
export var GO_TO_STEP = wizardActions.GO_TO_STEP;
export var SET_CURRENT_STEP_IS_INVALID = wizardActions.SET_CURRENT_STEP_IS_INVALID;
export var SET_SELECTED_NEW_PRODUCTS_TAB = wizardActions.SET_SELECTED_WIZARD_TAB;
export var SET_SHOPPING_CART_ITEM_INDEX = 'SET_SHOPPING_CART_ITEM_INDEX';
var TAX_AND_GL_CUSTOMER_ADDRESS_REQUIRED_ERROR_CODE = 11113;
export var reinitializeProductOrder = function reinitializeProductOrder() {
  return {
    type: INITIALIZE_PRODUCT_ORDER
  };
};
export var cancelOrder = wizardActions.cancelWizard;
export var goToNextStep = wizardActions.goToNextStep;
export var goToPreviousStep = wizardActions.goToPreviousStep;
export var goToStep = wizardActions.goToStep;
export var setCurrentStepIsInvalid = wizardActions.setCurrentStepIsInvalid;
export var setSelectedTab = wizardActions.setSelectedTab;
export var addToAndUpdateShoppingCart = function addToAndUpdateShoppingCart(_ref) {
  var productId = _ref.productId,
    pricingPlanId = _ref.pricingPlanId,
    childItems = _ref.childItems,
    instanceProperties = _ref.instanceProperties,
    quantity = _ref.quantity,
    customerId = _ref.customerId,
    shoppingCart = _ref.shoppingCart,
    redemptionCodes = _ref.redemptionCodes,
    standalone = _ref.standalone;
  var additionalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SIMPLE_EPHEMERAL_CART_OPTIONS;
  return function (dispatch) {
    var updatedCart = {
      Items: clone(shoppingCart.Items) || []
    };
    var cartItem = {
      ChildItems: Array.isArray(childItems) ? childItems : null,
      InstanceProperties: instanceProperties,
      IsStandalone: standalone,
      ProductId: productId,
      PricingPlanId: pricingPlanId,
      Quantity: quantity
    };
    updatedCart.Items.push(cartItem);
    return updateShoppingCartPromise(dispatch, customerId, updatedCart, redemptionCodes, additionalOptions);
  };
};
export var addMultipleAndUpdateShoppingCart = function addMultipleAndUpdateShoppingCart(_ref2) {
  var products = _ref2.products,
    redemptionCodes = _ref2.redemptionCodes,
    customerId = _ref2.customerId,
    shoppingCart = _ref2.shoppingCart;
  var additionalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SIMPLE_EPHEMERAL_CART_OPTIONS;
  return function (dispatch) {
    var updatedCart = {
      Items: clone(shoppingCart.Items) || []
    };
    // TODO Customer Order - why is this addedProductIds eveb needed? array built and not used it looks like
    var addedProductIds = [];
    products.forEach(function (product) {
      var cartItem = {
        AdHocOverrideDetails: product.adHocOverrideDetails,
        BundleId: product.bundleId,
        ChildItems: Array.isArray(product.childItems) ? product.childItems : null,
        PricingPlanId: product.pricingPlanId,
        ProductId: product.productId,
        Quantity: product.quantity,
        InstanceProperties: product.instanceProperties,
        // TODO Customer Order, this can be removed later a product already contains this info to send to SV for Quoting
        IsStandalone: product.standalone,
        ShoppingCartItemBillerRuleDetails: product.shoppingCartItemBillerRuleDetails
      };
      updatedCart.Items.push(cartItem);
      addedProductIds.push(product.productId);
    });
    return updateShoppingCartPromise(dispatch, customerId, updatedCart, redemptionCodes, additionalOptions);
  };
};
export var editMultipleAndUpdateShoppingCart = function editMultipleAndUpdateShoppingCart(_ref3) {
  var products = _ref3.products,
    redemptionCodes = _ref3.redemptionCodes,
    customerId = _ref3.customerId,
    shoppingCart = _ref3.shoppingCart;
  var additionalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SIMPLE_EPHEMERAL_CART_OPTIONS;
  return function (dispatch) {
    var updatedCart = {
      Items: clone(shoppingCart.Items)
    };
    products.forEach(function (product) {
      var targetItem = updatedCart.Items.find(function (item) {
        return item.PricingPlanId === product.pricingPlanId;
      });
      var addedProductIds = [];
      if (targetItem) {
        targetItem.PricingPlanId = product.pricingPlanId;
        targetItem.ChildItems = Array.isArray(product.childItems) ? product.childItems : [];
        targetItem.InstanceProperties = product.instanceProperties;
        targetItem.Quantity = product.quantity;
      } else {
        var cartItem = {
          BundleId: product.bundleId,
          ChildItems: Array.isArray(product.childItems) ? product.childItems : null,
          PricingPlanId: product.pricingPlanId,
          ProductId: product.productId,
          Quantity: product.quantity,
          InstanceProperties: product.instanceProperties
        };
        updatedCart.Items.push(cartItem);
        addedProductIds.push(product.productId);
      }
    });
    return updateShoppingCartPromise(dispatch, customerId, updatedCart, redemptionCodes, additionalOptions);
  };
};
export var editAndUpdateShoppingCart = function editAndUpdateShoppingCart(_ref4) {
  var index = _ref4.index,
    product = _ref4.product,
    instanceProperties = _ref4.instanceProperties,
    quantity = _ref4.quantity,
    customerId = _ref4.customerId,
    shoppingCart = _ref4.shoppingCart,
    redemptionCodes = _ref4.redemptionCodes;
  var additionalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SIMPLE_EPHEMERAL_CART_OPTIONS;
  return function (dispatch) {
    var updatedCart = {
      Items: clone(shoppingCart.Items)
    };
    var targetItem = updatedCart.Items[index];
    targetItem.PricingPlanId = product.pricingPlanId;
    targetItem.ChildItems = Array.isArray(product.childItems) ? product.childItems : [];
    targetItem.InstanceProperties = instanceProperties;
    targetItem.Quantity = quantity;
    return updateShoppingCartPromise(dispatch, customerId, updatedCart, redemptionCodes, additionalOptions);
  };
};
export var removeFromAndUpdateShoppingCart = function removeFromAndUpdateShoppingCart(_ref5) {
  var index = _ref5.index,
    customerId = _ref5.customerId,
    shoppingCart = _ref5.shoppingCart,
    redemptionCodes = _ref5.redemptionCodes;
  var additionalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SIMPLE_EPHEMERAL_CART_OPTIONS;
  return function (dispatch) {
    var updatedCart = {
      Items: remove(index, 1, shoppingCart.Items || [])
    };
    return updateShoppingCartPromise(dispatch, customerId, updatedCart, redemptionCodes, additionalOptions);
  };
};
export var updateShoppingCartWithLatest = function updateShoppingCartWithLatest(_ref6) {
  var customerId = _ref6.customerId,
    shoppingCart = _ref6.shoppingCart,
    redemptionCodes = _ref6.redemptionCodes,
    discretionaryDiscountIds = _ref6.discretionaryDiscountIds,
    discretionaryDiscountReasonCode = _ref6.discretionaryDiscountReasonCode;
  var additionalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SIMPLE_EPHEMERAL_CART_OPTIONS;
  return function (dispatch) {
    return updateShoppingCartPromise(dispatch, customerId, shoppingCart, redemptionCodes, additionalOptions, discretionaryDiscountIds, discretionaryDiscountReasonCode);
  };
};
export var calculateModifyOrderQuote = function calculateModifyOrderQuote(_ref7) {
  var customerId = _ref7.customerId,
    modificationObject = _ref7.modificationObject,
    _ref7$paymentInstrume = _ref7.paymentInstrumentIds,
    paymentInstrumentIds = _ref7$paymentInstrume === void 0 ? [] : _ref7$paymentInstrume,
    _ref7$redemptionCodes = _ref7.redemptionCodes,
    redemptionCodes = _ref7$redemptionCodes === void 0 ? [] : _ref7$redemptionCodes,
    _ref7$discretionaryDi = _ref7.discretionaryDiscounts,
    discretionaryDiscounts = _ref7$discretionaryDi === void 0 ? [] : _ref7$discretionaryDi,
    _ref7$shippingAddress = _ref7.shippingAddressId,
    shippingAddressId = _ref7$shippingAddress === void 0 ? null : _ref7$shippingAddress,
    _ref7$shippingMethodI = _ref7.shippingMethodId,
    shippingMethodId = _ref7$shippingMethodI === void 0 ? null : _ref7$shippingMethodI,
    _ref7$calculateShippi = _ref7.calculateShipping,
    calculateShipping = _ref7$calculateShippi === void 0 ? true : _ref7$calculateShippi,
    _ref7$calculateTaxes = _ref7.calculateTaxes,
    calculateTaxes = _ref7$calculateTaxes === void 0 ? true : _ref7$calculateTaxes,
    _ref7$useDefaults = _ref7.useDefaults,
    useDefaults = _ref7$useDefaults === void 0 ? true : _ref7$useDefaults;
  return function (dispatch) {
    dispatch(setCurrentStepIsInvalid(true));
    return calculateModifyOrderQuotePromise(dispatch, customerId, modificationObject, paymentInstrumentIds, redemptionCodes, discretionaryDiscounts, shippingAddressId, shippingMethodId, calculateShipping, calculateTaxes, useDefaults).then(function (response) {
      return response;
    }, function (error) {
      var errorMessage = i18n.translate(CustomerCareKeys.QUOTE_ERROR);
      if (error.translatedMessage) {
        errorMessage = error.translatedMessage;
      }
      getUiNotificationService().transientError(errorMessage);
      return error;
    }).finally(function () {
      // Make it ok for the user to submit again
      dispatch(setCurrentStepIsInvalid(false));
    });
  };
};
export var calculateOrderQuote = function calculateOrderQuote(_ref8) {
  var customerId = _ref8.customerId,
    shoppingCart = _ref8.shoppingCart,
    _ref8$orderTaxLocatio = _ref8.orderTaxLocation,
    orderTaxLocation = _ref8$orderTaxLocatio === void 0 ? null : _ref8$orderTaxLocatio,
    _ref8$paymentInstrume = _ref8.paymentInstrumentIds,
    paymentInstrumentIds = _ref8$paymentInstrume === void 0 ? [] : _ref8$paymentInstrume,
    _ref8$redemptionCodes = _ref8.redemptionCodes,
    redemptionCodes = _ref8$redemptionCodes === void 0 ? [] : _ref8$redemptionCodes,
    _ref8$discretionaryDi = _ref8.discretionaryDiscounts,
    discretionaryDiscounts = _ref8$discretionaryDi === void 0 ? [] : _ref8$discretionaryDi,
    _ref8$shippingAddress = _ref8.shippingAddressId,
    shippingAddressId = _ref8$shippingAddress === void 0 ? null : _ref8$shippingAddress,
    _ref8$shippingMethodI = _ref8.shippingMethodId,
    shippingMethodId = _ref8$shippingMethodI === void 0 ? null : _ref8$shippingMethodI,
    _ref8$useDefaults = _ref8.useDefaults,
    useDefaults = _ref8$useDefaults === void 0 ? true : _ref8$useDefaults,
    _ref8$recordPaymentIn = _ref8.recordPaymentInfo,
    recordPaymentInfo = _ref8$recordPaymentIn === void 0 ? true : _ref8$recordPaymentIn,
    _ref8$paymentInstrume2 = _ref8.paymentInstruments,
    paymentInstruments = _ref8$paymentInstrume2 === void 0 ? [] : _ref8$paymentInstrume2;
  return function (dispatch) {
    // Disallow the user from submitting again until the request is done
    dispatch(setCurrentStepIsInvalid(true));
    return calculateOrderQuotePromise(dispatch, customerId, shoppingCart, orderTaxLocation, paymentInstrumentIds, redemptionCodes, discretionaryDiscounts, shippingAddressId, shippingMethodId, useDefaults, recordPaymentInfo, paymentInstruments).catch(function (error) {
      if (error.Code !== TAX_AND_GL_CUSTOMER_ADDRESS_REQUIRED_ERROR_CODE) {
        var errorMessage = i18n.translate(CustomerCareKeys.QUOTE_ERROR);
        if (error.translatedMessage) {
          errorMessage = error.translatedMessage;
        }
        getUiNotificationService().transientError(errorMessage);
      }
    }).finally(function () {
      // Make it ok for the user to submit again
      dispatch(setCurrentStepIsInvalid(false));
    });
  };
};
export var calculateRenewOrderQuote = function calculateRenewOrderQuote(_ref9) {
  var customerId = _ref9.customerId,
    subscriptionId = _ref9.subscriptionId,
    _ref9$paymentInstrume = _ref9.paymentInstrumentIds,
    paymentInstrumentIds = _ref9$paymentInstrume === void 0 ? [] : _ref9$paymentInstrume,
    _ref9$redemptionCodes = _ref9.redemptionCodes,
    redemptionCodes = _ref9$redemptionCodes === void 0 ? [] : _ref9$redemptionCodes,
    _ref9$discretionaryDi = _ref9.discretionaryDiscounts,
    discretionaryDiscounts = _ref9$discretionaryDi === void 0 ? [] : _ref9$discretionaryDi,
    _ref9$shippingAddress = _ref9.shippingAddressId,
    shippingAddressId = _ref9$shippingAddress === void 0 ? null : _ref9$shippingAddress,
    _ref9$shippingMethodI = _ref9.shippingMethodId,
    shippingMethodId = _ref9$shippingMethodI === void 0 ? null : _ref9$shippingMethodI,
    _ref9$calculateTaxes = _ref9.calculateTaxes,
    calculateTaxes = _ref9$calculateTaxes === void 0 ? true : _ref9$calculateTaxes,
    _ref9$useDefaults = _ref9.useDefaults,
    useDefaults = _ref9$useDefaults === void 0 ? true : _ref9$useDefaults;
  return function (dispatch) {
    // Disallow the user from submitting again until the request is done
    dispatch(setCurrentStepIsInvalid(true));
    return calculateRenewOrderQuotePromise(dispatch, customerId, subscriptionId, paymentInstrumentIds, redemptionCodes, discretionaryDiscounts, shippingAddressId, shippingMethodId, calculateTaxes, useDefaults).catch(function (error) {
      var errorMessage = i18n.translate(CustomerCareKeys.QUOTE_ERROR);
      if (error.translatedMessage) {
        errorMessage = error.translatedMessage;
      }
      getUiNotificationService().transientError(errorMessage);
    }).finally(function () {
      // Make it ok for the user to submit again
      dispatch(setCurrentStepIsInvalid(false));
    });
  };
};
export var calculateChangeOfServiceOrderQuote = function calculateChangeOfServiceOrderQuote(_ref10) {
  var customerId = _ref10.customerId,
    addItems = _ref10.addItems,
    modifyItems = _ref10.modifyItems,
    removeItems = _ref10.removeItems,
    paymentInstrumentIds = _ref10.paymentInstrumentIds;
  return function (dispatch) {
    // Disallow the user from submitting again until the request is done
    dispatch(setCurrentStepIsInvalid(true));
    return calculateChangeOfServiceOrderQuoteRequestPromise(dispatch, customerId, addItems, modifyItems, removeItems, paymentInstrumentIds).catch(function (error) {
      var errorMessage = i18n.translate(CustomerCareKeys.QUOTE_ERROR);
      if (error.translatedMessage) {
        errorMessage = error.translatedMessage;
      }
      getUiNotificationService().transientError(errorMessage);
    }).finally(function () {
      // Make it ok for the user to submit again
      dispatch(setCurrentStepIsInvalid(false));
    });
  };
};
export var submitModifyOrder = function submitModifyOrder(_ref11) {
  var customerId = _ref11.customerId,
    modificationObject = _ref11.modificationObject,
    _ref11$paymentInstrum = _ref11.paymentInstrumentIds,
    paymentInstrumentIds = _ref11$paymentInstrum === void 0 ? [] : _ref11$paymentInstrum,
    _ref11$paymentInstrum2 = _ref11.paymentInstruments,
    paymentInstruments = _ref11$paymentInstrum2 === void 0 ? null : _ref11$paymentInstrum2,
    _ref11$recordPaymentI = _ref11.recordPaymentInfo,
    recordPaymentInfo = _ref11$recordPaymentI === void 0 ? null : _ref11$recordPaymentI,
    _ref11$redemptionCode = _ref11.redemptionCodes,
    redemptionCodes = _ref11$redemptionCode === void 0 ? [] : _ref11$redemptionCode,
    _ref11$discretionaryD = _ref11.discretionaryDiscounts,
    discretionaryDiscounts = _ref11$discretionaryD === void 0 ? [] : _ref11$discretionaryD,
    _ref11$discretionaryD2 = _ref11.discretionaryDiscountReasonCode,
    discretionaryDiscountReasonCode = _ref11$discretionaryD2 === void 0 ? null : _ref11$discretionaryD2,
    _ref11$shippingAddres = _ref11.shippingAddressId,
    shippingAddressId = _ref11$shippingAddres === void 0 ? null : _ref11$shippingAddres,
    _ref11$shippingMethod = _ref11.shippingMethodId,
    shippingMethodId = _ref11$shippingMethod === void 0 ? null : _ref11$shippingMethod,
    _ref11$shipToName = _ref11.shipToName,
    shipToName = _ref11$shipToName === void 0 ? null : _ref11$shipToName,
    additionalProperties = _ref11.additionalProperties;
  return function (dispatch) {
    // Disallow the user from submitting again until the request is done
    dispatch(setCurrentStepIsInvalid(true));
    return submitModifyOrderPromise(dispatch, customerId, modificationObject, paymentInstrumentIds, paymentInstruments, recordPaymentInfo, redemptionCodes, discretionaryDiscounts, discretionaryDiscountReasonCode, shippingAddressId, shippingMethodId, shipToName, additionalProperties).finally(function () {
      // Make it ok for the user to submit again
      dispatch(setCurrentStepIsInvalid(false));
    });
  };
};
export var submitRestoreOrder = function submitRestoreOrder(_ref12) {
  var customerId = _ref12.customerId,
    subscriptionId = _ref12.subscriptionId,
    paymentInstrumentIds = _ref12.paymentInstrumentIds,
    recordPaymentInfo = _ref12.recordPaymentInfo,
    _ref12$redemptionCode = _ref12.redemptionCodes,
    redemptionCodes = _ref12$redemptionCode === void 0 ? [] : _ref12$redemptionCode,
    _ref12$discretionaryD = _ref12.discretionaryDiscounts,
    discretionaryDiscounts = _ref12$discretionaryD === void 0 ? [] : _ref12$discretionaryD,
    _ref12$discretionaryD2 = _ref12.discretionaryDiscountReasonCode,
    discretionaryDiscountReasonCode = _ref12$discretionaryD2 === void 0 ? null : _ref12$discretionaryD2,
    _ref12$shippingAddres = _ref12.shippingAddressId,
    shippingAddressId = _ref12$shippingAddres === void 0 ? null : _ref12$shippingAddres,
    _ref12$shippingMethod = _ref12.shippingMethodId,
    shippingMethodId = _ref12$shippingMethod === void 0 ? null : _ref12$shippingMethod,
    _ref12$shipToName = _ref12.shipToName,
    shipToName = _ref12$shipToName === void 0 ? null : _ref12$shipToName,
    _ref12$waiveFee = _ref12.waiveFee,
    waiveFee = _ref12$waiveFee === void 0 ? false : _ref12$waiveFee,
    _ref12$waiveFeeReason = _ref12.waiveFeeReason,
    waiveFeeReason = _ref12$waiveFeeReason === void 0 ? null : _ref12$waiveFeeReason,
    _ref12$waiveLateFee = _ref12.waiveLateFee,
    waiveLateFee = _ref12$waiveLateFee === void 0 ? false : _ref12$waiveLateFee,
    _ref12$waiveLateFeeRe = _ref12.waiveLateFeeReason,
    waiveLateFeeReason = _ref12$waiveLateFeeRe === void 0 ? null : _ref12$waiveLateFeeRe;
  return function (dispatch) {
    // Disallow the user from submitting again until the request is done
    dispatch(setCurrentStepIsInvalid(true));
    return submitRestoreOrderPromise(dispatch, customerId, subscriptionId, paymentInstrumentIds, [], recordPaymentInfo, redemptionCodes, discretionaryDiscounts, discretionaryDiscountReasonCode, shippingAddressId, shippingMethodId, shipToName, waiveFee, waiveFeeReason, waiveLateFee, waiveLateFeeReason).finally(function () {
      // Make it ok for the user to submit again
      dispatch(setCurrentStepIsInvalid(false));
    });
  };
};
export var submitOrder = function submitOrder(_ref13) {
  var customerId = _ref13.customerId,
    shoppingCart = _ref13.shoppingCart,
    _ref13$orderTaxLocati = _ref13.orderTaxLocation,
    orderTaxLocation = _ref13$orderTaxLocati === void 0 ? null : _ref13$orderTaxLocati,
    _ref13$paymentInstrum = _ref13.paymentInstrumentIds,
    paymentInstrumentIds = _ref13$paymentInstrum === void 0 ? [] : _ref13$paymentInstrum,
    _ref13$paymentInstrum2 = _ref13.paymentInstruments,
    paymentInstruments = _ref13$paymentInstrum2 === void 0 ? [] : _ref13$paymentInstrum2,
    _ref13$recordPaymentI = _ref13.recordPaymentInfo,
    recordPaymentInfo = _ref13$recordPaymentI === void 0 ? true : _ref13$recordPaymentI,
    _ref13$redemptionCode = _ref13.redemptionCodes,
    redemptionCodes = _ref13$redemptionCode === void 0 ? [] : _ref13$redemptionCode,
    _ref13$discretionaryD = _ref13.discretionaryDiscounts,
    discretionaryDiscounts = _ref13$discretionaryD === void 0 ? [] : _ref13$discretionaryD,
    _ref13$discretionaryD2 = _ref13.discretionaryDiscountReasonCode,
    discretionaryDiscountReasonCode = _ref13$discretionaryD2 === void 0 ? null : _ref13$discretionaryD2,
    executionOptions = _ref13.executionOptions,
    _ref13$shippingAddres = _ref13.shippingAddressId,
    shippingAddressId = _ref13$shippingAddres === void 0 ? null : _ref13$shippingAddres,
    _ref13$shippingMethod = _ref13.shippingMethodId,
    shippingMethodId = _ref13$shippingMethod === void 0 ? null : _ref13$shippingMethod,
    _ref13$shipToName = _ref13.shipToName,
    shipToName = _ref13$shipToName === void 0 ? null : _ref13$shipToName,
    _ref13$offeringId = _ref13.offeringId,
    offeringId = _ref13$offeringId === void 0 ? null : _ref13$offeringId,
    _ref13$useDefaults = _ref13.useDefaults,
    useDefaults = _ref13$useDefaults === void 0 ? true : _ref13$useDefaults,
    additionalProperties = _ref13.additionalProperties,
    orderDetails = _ref13.orderDetails;
  return function (dispatch) {
    // Disallow the user from submitting again until the request is done
    dispatch(setCurrentStepIsInvalid(true));
    return submitOrderPromise(dispatch, customerId, shoppingCart, orderTaxLocation, paymentInstrumentIds, paymentInstruments, recordPaymentInfo, redemptionCodes, discretionaryDiscounts, discretionaryDiscountReasonCode, executionOptions, shippingAddressId, shippingMethodId, shipToName, offeringId, useDefaults, additionalProperties, orderDetails).finally(function () {
      // Make it ok for the user to submit again
      dispatch(setCurrentStepIsInvalid(false));
    });
  };
};
export var submitServiceFeatureOrder = function submitServiceFeatureOrder(_ref14) {
  var customerId = _ref14.customerId,
    addItems = _ref14.addItems,
    modifyItems = _ref14.modifyItems,
    removeItems = _ref14.removeItems,
    paymentInstrumentIds = _ref14.paymentInstrumentIds,
    executionOptions = _ref14.executionOptions,
    additionalProperties = _ref14.additionalProperties;
  return function (dispatch) {
    // Disallow the user from submitting again until the request is done
    dispatch(setCurrentStepIsInvalid(true));
    return submitServiceFeatureOrderPromise(dispatch, customerId, addItems, modifyItems, removeItems, paymentInstrumentIds, executionOptions, additionalProperties).finally(function () {
      // Make it ok for the user to submit again
      dispatch(setCurrentStepIsInvalid(false));
    });
  };
};
export var submitGiftOrder = function submitGiftOrder(_ref15) {
  var customerId = _ref15.customerId,
    shoppingCart = _ref15.shoppingCart,
    paymentInstrumentIds = _ref15.paymentInstrumentIds,
    paymentInstruments = _ref15.paymentInstruments,
    recordPaymentInfo = _ref15.recordPaymentInfo,
    giftOrderInfo = _ref15.giftOrderInfo,
    _ref15$redemptionCode = _ref15.redemptionCodes,
    redemptionCodes = _ref15$redemptionCode === void 0 ? [] : _ref15$redemptionCode,
    _ref15$discretionaryD = _ref15.discretionaryDiscounts,
    discretionaryDiscounts = _ref15$discretionaryD === void 0 ? [] : _ref15$discretionaryD,
    _ref15$discretionaryD2 = _ref15.discretionaryDiscountReasonCode,
    discretionaryDiscountReasonCode = _ref15$discretionaryD2 === void 0 ? null : _ref15$discretionaryD2,
    _ref15$shippingAddres = _ref15.shippingAddressId,
    shippingAddressId = _ref15$shippingAddres === void 0 ? null : _ref15$shippingAddres,
    _ref15$shippingMethod = _ref15.shippingMethodId,
    shippingMethodId = _ref15$shippingMethod === void 0 ? null : _ref15$shippingMethod,
    _ref15$shipToName = _ref15.shipToName,
    shipToName = _ref15$shipToName === void 0 ? null : _ref15$shipToName,
    additionalProperties = _ref15.additionalProperties;
  return function (dispatch) {
    dispatch(setCurrentStepIsInvalid(true));
    return submitGiftOrderPromise(dispatch, customerId, shoppingCart, paymentInstrumentIds, paymentInstruments, recordPaymentInfo, giftOrderInfo, redemptionCodes, discretionaryDiscounts, discretionaryDiscountReasonCode, shippingAddressId, shippingMethodId, shipToName, additionalProperties).finally(function () {
      // Make it ok for the user to submit again
      dispatch(setCurrentStepIsInvalid(false));
    });
  };
};
export var clearOrderQuote = function clearOrderQuote() {
  return function (dispatch) {
    dispatch(clearProductOrderQuote());
  };
};
export var SET_PAYMENT_INSTRUMENT_IDS = 'SET_PAYMENT_INSTRUMENT_IDS';
export var setPaymentInstrumentIds = function setPaymentInstrumentIds(arrayOfIds) {
  return {
    type: SET_PAYMENT_INSTRUMENT_IDS,
    payload: arrayOfIds
  };
};
export var SET_PAYMENT_INSTRUMENTS = 'SET_PAYMENT_INSTRUMENTS';
export var setPaymentInstruments = function setPaymentInstruments(arrayOfIds) {
  return {
    type: SET_PAYMENT_INSTRUMENTS,
    payload: arrayOfIds
  };
};
export var SET_CHANGE_IMMEDIATELY = 'SET_CHANGE_IMMEDIATELY';
export var setChangeImmediately = function setChangeImmediately(changeImmediately) {
  return {
    type: SET_CHANGE_IMMEDIATELY,
    payload: changeImmediately
  };
};
export var SET_PRODUCT_ORDER_SHIPPING_ADDRESS_ID = 'SET_PRODUCT_ORDER_SHIPPING_ADDRESS_ID';
export var setProductOrderShippingAddressId = function setProductOrderShippingAddressId(shippingAddressId) {
  return {
    type: SET_PRODUCT_ORDER_SHIPPING_ADDRESS_ID,
    payload: shippingAddressId
  };
};
export var SET_IS_SHIPPING_ADDRESS_SAME_AS_BILLING = 'SET_IS_SHIPPING_ADDRESS_SAME_AS_BILLING';
export var setIsShippingAddressSameAsBilling = function setIsShippingAddressSameAsBilling(isShippingAddressSameAsBilling) {
  return {
    type: SET_IS_SHIPPING_ADDRESS_SAME_AS_BILLING,
    payload: isShippingAddressSameAsBilling
  };
};
export var SET_PRODUCT_ORDER_SHIPPING_METHOD_ID = 'SET_PRODUCT_ORDER_SHIPPING_METHOD_ID';
export var setSelectedShippingMethodId = function setSelectedShippingMethodId(shippingMethodId) {
  return {
    type: SET_PRODUCT_ORDER_SHIPPING_METHOD_ID,
    payload: shippingMethodId
  };
};
export var setShoppingCartItemIndex = function setShoppingCartItemIndex(cartItemIndex) {
  return {
    type: SET_SHOPPING_CART_ITEM_INDEX,
    payload: cartItemIndex
  };
};
export var SET_TEMPORARY_SHIP_TO_NAME = 'SET_TEMPORARY_SHIP_TO_NAME';
export var setTemporaryShipToName = function setTemporaryShipToName(temporaryShipToName) {
  return {
    type: SET_TEMPORARY_SHIP_TO_NAME,
    payload: temporaryShipToName
  };
};
export var SET_GIFT_ORDER_INFO = 'SET_GIFT_ORDER_INFO';
export var setGiftOrderInfo = function setGiftOrderInfo(giftOrderInfo) {
  return {
    type: SET_GIFT_ORDER_INFO,
    payload: giftOrderInfo
  };
};
export var SET_RESTORE_ORDER_WAIVE_FEE = 'SET_RESTORE_ORDER_WAIVE_FEE';
export var setRestoreOrderWaiveFee = function setRestoreOrderWaiveFee(waiveFee) {
  return {
    type: SET_RESTORE_ORDER_WAIVE_FEE,
    payload: waiveFee
  };
};
export var SET_RESTORE_ORDER_WAIVE_LATE_FEE = 'SET_RESTORE_ORDER_WAIVE_LATE_FEE';
export var setRestoreOrderWaiveLateFee = function setRestoreOrderWaiveLateFee(waiveLateFee) {
  return {
    type: SET_RESTORE_ORDER_WAIVE_LATE_FEE,
    payload: waiveLateFee
  };
};
export var SET_RESTORE_ORDER_WAIVE_FEE_REASON = 'SET_RESTORE_ORDER_WAIVE_FEE_REASON';
export var setRestoreOrderWaiveFeeReason = function setRestoreOrderWaiveFeeReason(waiveFeeReason) {
  return {
    type: SET_RESTORE_ORDER_WAIVE_FEE_REASON,
    payload: waiveFeeReason
  };
};
export var SET_RESTORE_ORDER_WAIVE_LATE_FEE_REASON = 'SET_RESTORE_ORDER_WAIVE_LATE_FEE_REASON';
export var setRestoreOrderWaiveLateFeeReason = function setRestoreOrderWaiveLateFeeReason(waiveLateFeeReason) {
  return {
    type: SET_RESTORE_ORDER_WAIVE_LATE_FEE_REASON,
    payload: waiveLateFeeReason
  };
};
export var SET_IS_GIFT_ORDER = 'SET_IS_GIFT_ORDER';
export var setIsGiftOrder = function setIsGiftOrder(isGiftOrder) {
  return {
    type: SET_IS_GIFT_ORDER,
    payload: isGiftOrder
  };
};
export var SET_OTT_EXECUTION_OPTIONS = 'SET_OTT_EXECUTION_OPTIONS';
export var setOttExecutionOptions = function setOttExecutionOptions(executionOptions) {
  return {
    type: SET_OTT_EXECUTION_OPTIONS,
    payload: executionOptions
  };
};
export var UPDATE_SERVICE_FEATURE_QUANTITY = 'UPDATE_SERVICE_FEATURE_QUANTITY';
export var updateServiceFeatureQuantity = function updateServiceFeatureQuantity(payload) {
  return {
    type: UPDATE_SERVICE_FEATURE_QUANTITY,
    payload: payload
  };
};
export var updateServiceFeatureQuantityPromise = function updateServiceFeatureQuantityPromise(payload) {
  return function (dispatch) {
    dispatch(updateServiceFeatureQuantity(payload));
    return Promise.resolve();
  };
};
export var UPDATE_SHOPPING_CART = {
  BEGIN: "".concat(ACTION_PREFIX, "_UPDATE_SHOPPING_CART_BEGIN"),
  SUCCESS: "".concat(ACTION_PREFIX, "_UPDATE_SHOPPING_CART_SUCCESS"),
  FAILURE: "".concat(ACTION_PREFIX, "_UPDATE_SHOPPING_CART_FAILURE")
};
export var UPDATE_SHOPPING_CART_EVENTS = [UPDATE_SHOPPING_CART.BEGIN, UPDATE_SHOPPING_CART.SUCCESS, UPDATE_SHOPPING_CART.FAILURE];
export var updateShoppingCartPromise = function updateShoppingCartPromise(dispatch, customerId, shoppingCart) {
  var redemptionCodes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var additionalOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var discretionaryDiscountIds = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var discretionaryDiscountReasonCode = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return ThunkHelper(dispatch, UPDATE_SHOPPING_CART_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateShoppingCart',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: Object.assign({
      CombineProducts: false,
      DiscretionaryDiscountReasonCode: discretionaryDiscountReasonCode,
      DiscretionaryDiscounts: discretionaryDiscountIds,
      PersistCart: true,
      RedemptionCodes: redemptionCodes,
      ShoppingCart: transformCartItemInstanceProperties(shoppingCart)
    }, additionalOptions)
  });
};
export var updateShoppingCart = function updateShoppingCart(customerId, shoppingCart, redemptionCodes) {
  var additionalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return function (dispatch) {
    return updateShoppingCartPromise(dispatch, customerId, shoppingCart, redemptionCodes, additionalOptions);
  };
};
export var SET_EDIT_ORDER_ADDITIONAL_PROPERTY = "".concat(ACTION_PREFIX, "_SET_EDIT_ORDER_ADDITIONAL_PROPERTY");
export var setEditOrderAdditionalProperty = function setEditOrderAdditionalProperty(additionalProperties) {
  return {
    type: SET_EDIT_ORDER_ADDITIONAL_PROPERTY,
    payload: additionalProperties
  };
};
export var SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE = "".concat(ACTION_PREFIX, "_SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE");
export var setEditOrderAdditionalPropertyOnChange = function setEditOrderAdditionalPropertyOnChange(id, newValue) {
  return {
    type: SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE,
    payload: {
      id: id,
      newValue: newValue
    }
  };
};
export var SET_ORDER_DETAILS = 'SET_ORDER_DETAILS';
export var setOrderDetails = function setOrderDetails(orderDetails) {
  return {
    type: SET_ORDER_DETAILS,
    payload: orderDetails
  };
};